export const GLOBAL_STATE = 'TeacherDashboard'

export const DASHBOARD_TEACHER = 'DASHBOARD_TEACHER' as const
